import { FC, useEffect, useMemo } from 'react';
// Types
import { Dimension } from 'app/store/BillingUsage/BillingUsage.types';
// Store
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Async
import { getUsage } from 'app/store/BillingUsage/BillingUsage.async';
// Selectors
import { selectParams, selectUsages, selectValidateDateRange } from 'app/store/BillingUsage/BillingUsage.selectors';
// Mui
import { Box } from '@mui/material';
// Components
import DataLoader from 'app/components/DataLoader';
// 
import CostExplorerDrawer from './CostExplorerDrawer';
import UsageByService from './UsageByService';
import UsageByCase from './UsageByCase';
import UsageByCaseService from './UsageByCaseService';
import UsageNoDataFound from './UsageNoDataFound';
import UsageBySubscriptionServiceInvoice from './UsageBySubscriptionServiceInvoice';
// Mixpanel
import MixpanelActions from 'app/features/mixpanel/MixpanelActions';

const CostExplorerTabContent:FC = () => {
  const dispatch = useAppDispatch();
  // State
  const params = useAppSelector(selectParams);
  const validationErrors = useAppSelector(selectValidateDateRange);

  const formattedParams = useMemo(() => {
    const formattedStart = params['period.start'] ? params['period.start'].format('YYYY-MM-DD') : null;
    const formattedEnd = params['period.end'] ? params['period.end'].add(1, 'day').format('YYYY-MM-DD') : null;
    return {
      ...params,
      'reference:case': params['reference:case'] ? (params['reference:case'] as any).id : null,
      'period.start': formattedStart,
      'period.end': formattedEnd
    };
  }, [params]);

  useEffect(() => {
    dispatch(MixpanelActions.handleCostExplorerView());
    // eslint-disable-next-line
  }, []);

  return (
    <Box sx={{ height: '100%', display: 'flex' }}>
      <CostExplorerDrawer />
      <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, overflow: 'hidden', p: 4 }}>
        <DataLoader
          asyncThunkFn={validationErrors ? undefined : getUsage}
          params={formattedParams}
          selector={selectUsages}
          noData={<UsageNoDataFound />}
        >
          {( data ) => (
            (() => {
              switch (params.dimensions) {
                case Dimension.Service:
                  return <UsageByService data={data} />
                case Dimension.Case:
                  return <UsageByCase data={data} />
                case Dimension.CaseService:
                  return <UsageByCaseService data={data} />
                default:
                  return <UsageBySubscriptionServiceInvoice data={data} />
              }
            })()
          )}
        </DataLoader>
      </Box>
    </Box>
  )
}

export default CostExplorerTabContent;
